<script lang="ts">
  import { route } from '@mateothegreat/svelte5-router'
  import { dt } from '../../constants/dt'
  import i18n from '../../i18n'
  import { ImageOff } from '@lucide/svelte'

  type Props = {
    project: Project
  }

  let { project }: Props = $props()
</script>

<a class="project" href={`/projects/${project.id}`} use:route>
  {#if project.previewImage}
    <img alt={project.name} src={project.previewImage} />
  {:else}
    <div class="no-picture-container">
      <ImageOff />
    </div>
  {/if}
  <div class="content">
    <p>{project.name}</p>
    <small>
      {$i18n.t('projects.project.edited', {
        editedAt: dt.fromISO(project.updatedAt).toRelative(),
      })}
    </small>
  </div>
</a>

<style lang="scss">
  .project {
    width: 100%;
    height: 15rem;
    border-radius: 1rem;
    position: relative;
    border-radius: 1rem;
    overflow: hidden;

    .no-picture-container {
      align-items: center;
      background: var(--input-background);
      display: flex;
      height: calc(100% - 3.25rem);
      justify-content: center;
      color: var(--foreground);
    }

    img {
      height: 100%;
      width: 100%;
      object-fit: cover;
    }

    .content {
      bottom: 0;
      left: 0;
      right: 0;
      position: absolute;
      backdrop-filter: var(--blur);
      min-height: 3.25rem;
      padding: 0 1.5rem;
      display: flex;
      flex-direction: column;
      justify-content: center;
      background: var(--blurred-background);
      color: var(--blurred-foreground);
      text-decoration: none;
      outline: none;

      * {
        color: inherit;
      }

      p {
        font-weight: 700;
        line-height: 130%;
      }

      small {
        font-size: 0.75rem;
      }
    }
    &:hover {
      .content {
        background: var(--blurred-hover-background);
      }
    }

    &:has(.content:focus-visible) {
      outline: 1px solid var(--stroke);
      outline-offset: 2px;
    }
  }
</style>
